module.exports = __webpack_public_path__ + "img/Weapon_51.d033493a.png";